
const getNavigationUrl = (where, data) => {
  let url = '';
  switch(where) {
    case 'SHOPPING_CART':
      url = '/cart';
      break;
    case 'UPLOAD_PICTURES':
      url = '/upload';
      break;
    case 'PRODUCT_CATEGORIES':
      url = '/products';
      break;
    case 'CHECKOUT':
      url = '/cart/checkout';
      break;
    case 'CHECKOUT_DELIVERY':
      url = '/cart/checkout/delivery-options';
      break;

  }
  return url;
}

export default {
  SHOPPING_CART: '/cart/',
}

export {
  getNavigationUrl
}